import { render, staticRenderFns } from "./XpcapConfigModal.vue?vue&type=template&id=b1c876f4&"
import script from "./XpcapConfigModal.vue?vue&type=script&lang=js&"
export * from "./XpcapConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports